import { useWrite } from '@bw/hookshot';
import config from 'utils/config';

type UseSendTNVerificationCode = {
  input: {
    email: string;
    phoneNumber: string;
    code: string;
  };
};

export interface SendTNVerificationResponse {
  message: string;
  status: string;
  registrationId: string;
}

export const useSendTNVerificationCode = () => {
  return useWrite<UseSendTNVerificationCode, SendTNVerificationResponse>(
    `${config.expressApi}/verify`,
    'POST',
    {
      requestFormat: 'json',
      fetchOptions: {
        headers: {
          /* eslint-disable-next-line @typescript-eslint/naming-convention */
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      },
    },
  );
};
